export function captureException(
  err: Error,
  options: {
    extra?: {
      [tagName: string]: string | number | boolean;
    };
    tags?: {
      [tagName: string]: string | number | boolean;
    };
  }
) {
  return console.error(err, options);
}
